import { render } from "./DataQualityScorecardTable.vue?vue&type=template&id=ec51b6f8&scoped=true"
import script from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"
export * from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"

import "./DataQualityScorecardTable.vue?vue&type=style&index=0&id=ec51b6f8&scoped=true&lang=css"
import "./DataQualityScorecardTable.vue?vue&type=style&index=1&id=ec51b6f8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec51b6f8"]])

export default __exports__